import React from "react";
import { ClearAllProps, useFilters } from "@usereactify/search";

export type ExampleClearAllProps = React.ComponentProps<
    NonNullable<ClearAllProps["render"]>
>;

export const ClearAll: React.FC<ExampleClearAllProps> = (props) => {
    const filtersHook = useFilters();

    console.log("FILTERS", filtersHook);

    // Check if any filter object has a value array with length > 0
    const hasSelectedFilters = filtersHook.selected.some(
        (filter) => filter.value && filter.value.length > 0
    );

    return (
        <>
            {hasSelectedFilters && (
                <a className={`h4 underline`} onClick={props.clearAll}>{"Clear All"}</a>
            )}
        </>
    );
};